//////LIBRARY//////
import React, { useEffect, useState, Fragment, useMemo } from 'react'
import moment from 'moment'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { bindActionCreators } from 'redux'
import styled from 'styled-components'
import { cloneDeep, isEmpty, isUndefined, map, isEqual, reduce } from 'lodash'
//////COMPONENTS//////
import Table from '../../components/Table'
import { LogExtranetManagerNested } from './Components'
import { logExtranetActionCreators, columnsActionCreators, tableActionCreators } from '../../store/actions'
import Button from '../../components/Ui/Buttons'
import Theme from '../../theme/theme'
import Modals from '../../components/Modals'
import DropdownCheckbox from '../../components/DropdownCheckbox'
import UseDatePicker from '../../hooks/UseDatePicker'
import { TextModal, DatePickerFilterLabel } from '../../theme/GlobalCss'
import UseCheckAll from '../../hooks/UseCheckAll'
import urlExport from '../../constants/UrlExport'
import userPrivileges from '../../constants/PrivilegesList'
import TableTitle from '../../components/Table/components/TableTitle'
//////ASSETS//////
import Calendar from '../../assets/icones/global/calendar.svg'
import Validation from '../../assets/icones/global/check.svg'
import Cancel from '../../assets/icones/global/close-white.svg'

//////STYLED//////
const UsersManagerWrapper = styled.div`
	position: relative;
`
const DatePickerTransactionIcon = styled.div`
	border-radius: 4px;
	background-color: ${(props) => props.theme.colors.primary};
	height: 32px;
	width: 32px;
	padding: 6px;
	box-sizing: border-box;
	cursor: pointer;
	background-image: url(${Calendar});
	background-repeat: no-repeat;
	background-size: 20px 20px;
	background-position: center;
	:hover {
		background-color: ${(props) => props.theme.colors.hoverPrimary};
	}
	transition: background-color 0.1s;
`
const ButtonWrapper = styled.div`
	display: flex;
	height: 32px;
	width: 100%;
	justify-content: space-between;
`
//////STYLED//////

const LogExtranetManager = () => {
	// Filters
	const [prevFilter, setPrevFilter] = useState({})
	const [filters, setFilters, handleCheckElements] = UseCheckAll(prevFilter)

	// Data
	const [paging, setPaging] = useState({ page: '0', size: '250', sort: 'dateCreated', nameDir: 'desc' })
	const [inputData, setInputData] = useState([])

	// Search bar
	const [searchValue, setSearchValue] = useState()

	// Modals
	const [showModalTicket, setShowModalTicket] = useState(false)

	const { user, translations, logExtranet, logExtranetFilters, userKioskPerimeter, isSearchfieldUpdated, currentColumn, currentDir } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			logExtranet: state.logExtranet,
			logExtranetFilters: state.logExtranet.header || false,
			user: state.user,
			userKioskPerimeter: state.user.identity.kioskSelected,
			isSearchfieldUpdated: state.columns.isSearchfieldUpdated,
			currentColumn: state.columns.currentColumn,
			currentDir: state.columns.currentDir,
		}),
		shallowEqual
	)

	const [currentPerimeterKiosks, setCurrentPerimeterKiosks] = useState([])

	const actionsLogExtranet = bindActionCreators(logExtranetActionCreators, useDispatch())
	const actionsColumns = bindActionCreators(columnsActionCreators, useDispatch())
	const actionsTable = bindActionCreators(tableActionCreators, useDispatch())

	const [
		dateTransactionShowModal,
		dateTransactionOpenDateModalHandler,
		dateTransactionRenderModal,
		dateTransactionStateDate,
		setStartDate,
		setEndDate,
	] = UseDatePicker({
		defaultDateStart: moment().startOf('day').toDate(),
		defaultDateEnd: moment().hours(23).minutes(59).toDate(),
	})

	// Columns
	const [columns, setColumns] = useState([])

	///////////////////////////////HANDLER ////////////////////////////////////////

	const handleModalTicket = (dataRow) => {
		setShowModalTicket((prevState) => !prevState)
	}
	const handleSearchEnter = (e, val) => {
		if (e.keyCode !== 13) return
		setSearchValue(val)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleClickSearch = (refInput) => {
		setSearchValue(refInput.current.value)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleSubmit = () => {
		if (isEqual(filters, prevFilter)) return // guard to call if no change
		setPrevFilter(filters)

		// Force reset paging at zero, in case when filters are preventing any pagination with current size
		let pg = cloneDeep(paging)
		if (isUndefined(pg)) {
			pg = { page: '0', size: '250', sort: 'dateCreated', nameDir: 'desc' }
		} else {
			pg.page = '0'
		}
		setPaging(pg)
		actionsLogExtranet.postLogExtranet(handleFilterSend(), pg)
	}
	const handleFilterSend = () => {
		const filtersIn = cloneDeep(filters)
		let searchFieldUpdated = {}
		let filtersOut = {}

		if (isSearchfieldUpdated) {
			searchFieldUpdated = {
				searchFieldUpdated: true,
			}
		} else {
			searchFieldUpdated = {
				searchFieldUpdated: false,
			}
		}
		filtersOut = { ...searchFieldUpdated, ...filtersIn }
		return {
			withFilters: true,
			userKioskScope: {
				kiosksInLocalScope: reduce(
					user.identity.kioskSelected,
					(result, value) => {
						result.push(value.id)
						return result
					},
					[]
				),
			},
			datesRange: {
				dateStart: dateTransactionStateDate.date.endDate,
				dateEnd: dateTransactionStateDate.date.startDate,
			},
			searchField: filters.searchField?.length > 0 ? filters.searchField : '',
			...filtersOut,
		}
	}

	const handlePagingLogExtranet = (paging) => {
		const pg = {
			...paging,
			...{
				sort: !isUndefined(currentColumn.value) ? currentColumn.value : 'dateCreated',
				nameDir: !isUndefined(currentDir.value) ? currentDir.value : 'desc',
			},
		}
		setPaging(pg)
		actionsLogExtranet.postLogExtranet(handleFilterSend(), pg)
	}

	/////////////////////////////// CONFIG //////////////////////////////////////

	useEffect(() => {
		setColumns([
			/* { dataHook: 'id', headerName: '', "isAuthorize": false, component: SalesHistoryToggleNested, sortable: false },*/
			{
				columnReferential: 'extranetLog_status',
				dataHook: 'status',
				headerName: translations['page__logAdmin__tableHeader_status'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
				sortableId: 'statusTranslationKey.id',
			},
			{
				columnReferential: 'extranetLog_logId',
				dataHook: 'idLog',
				headerName: translations['page__logAdmin__tableHeader_logId'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'id',
			},
			{
				columnReferential: 'extranetLog_dateHour',
				dataHook: 'date',
				headerName: translations['page__logAdmin__tableHeader_date'],
				sortable: true,
				isAuthorize: true,
				component: (props) => moment(props.row.date).format('DD/MM/YYYY HH:mm'),
				sortableId: 'dateCreated',
			},
			{
				columnReferential: 'extranetLog_category',
				dataHook: 'category',
				headerName: translations['page__logAdmin__tableHeader_category'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
				sortableId: 'categoryTranslationKey.id',
			},
			{
				columnReferential: 'extranetLog_subCategory',
				dataHook: 'subCategory',
				headerName: translations['page__logAdmin__tableHeader_subCategory'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
				sortableId: 'subCategoryTranslationKey.id',
			},
			{
				columnReferential: 'extranetLog_store',
				dataHook: 'store',
				headerName: translations['page__logAdmin__tableHeader_store'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'storeCompany.labelToDisplay',
			},
			{
				columnReferential: 'extranetLog_kioskCode',
				dataHook: 'kioskCode',
				headerName: translations['page__logAdmin__tableHeader_kioskCode'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'kiosk.labelToManufacturer',
			},
			{
				columnReferential: 'extranetLog_kioskName',
				dataHook: 'kioskName',
				headerName: translations['page__logAdmin__tableHeader_kioskName'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'kiosk.description',
			},
			{
				columnReferential: 'extranetLog_clientKioskCode',
				dataHook: 'customerKioskCode',
				headerName: translations['page__logAdmin__tableHeader_customerKioskName'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'kiosk.labelToOwner',
			},
			{
				columnReferential: 'extranetLog_event',
				dataHook: 'event',
				headerName: translations['page__logAdmin__tableHeader_event'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
				sortableId: 'eventTranslationKey.id',
			},
			{
				columnReferential: 'extranetLog_canal',
				dataHook: 'canal',
				headerName: translations['page__logAdmin__tableHeader_canal'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
				sortableId: 'canalTranslationKey.id',
			},
			{
				columnReferential: 'extranetLog_level',
				dataHook: 'level',
				headerName: translations['page__logAdmin__tableHeader_level'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
				sortableId: 'levelTranslationKey.id',
			},
			{
				columnReferential: 'extranetLog_createdBy',
				dataHook: 'userCreated',
				headerName: translations['page__logAdmin__tableHeader_createBy'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'createdBy.username',
			},
			{
				columnReferential: 'extranetLog_raisedBy',
				dataHook: 'userRaised',
				headerName: translations['page__logAdmin__tableHeader_raisedBy'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'raiser.username',
			},
			{
				columnReferential: 'extranetLog_fixedBy',
				dataHook: 'userFixed',
				headerName: translations['page__logAdmin__tableHeader_fixedBy'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'fixer.username',
			},
		])
	}, [translations])

	// Used for columns displaying (redux stored)
	const tableReferential = {
		idPageTable: 19,
		labelPageTable: 'extranetLog',
	}

	const [configTableTitle, setConfigTableTitle] = useState({
		actions: {
			searchBarComponent: {
				handleSearchEnter: handleSearchEnter,
				handleClickSearch: handleClickSearch,
				placeholder: translations['common__text__fastFilter_search'],
				handleReset: (refInput) => {
					refInput.current.value = ''
					setSearchValue('')
				},
			},

			dateLists: [
				() => (
					<Fragment>
						<label style={{ color: Theme.colors.table.body.text, marginRight: '10px', lineHeight: '32px' }}>
							{translations['page__logAdmin__filters_date']} :
						</label>
						<DatePickerTransactionIcon onClick={dateTransactionOpenDateModalHandler} />
						<DatePickerFilterLabel>
							<span>
								{translations['page__global__admin__header_datePicker_from']}{' '}
								{isEqual(dateTransactionStateDate.date.startDate, {})
									? moment(new Date()).format('DD/MM/YYYY HH:mm')
									: moment(dateTransactionStateDate.date.startDate).format('DD/MM/YYYY HH:mm')}
							</span>
							<span>
								{translations['page__global__admin__header_datePicker_to']}{' '}
								{isEqual(dateTransactionStateDate.date.endDate, {})
									? moment(new Date()).format('DD/MM/YYYY HH:mm')
									: moment(dateTransactionStateDate.date.endDate).format('DD/MM/YYYY HH:mm')}
							</span>
						</DatePickerFilterLabel>
					</Fragment>
				),
			],
		},
		paging: {
			fnSendTo: (paging) => handlePagingLogExtranet(paging),
		},
	})
	const [configTable, setConfigTable] = useState({
		nestedValues: {
			value: true,
			nestedData: 'message',
			nestedComponent: LogExtranetManagerNested,
			nestedPointer: 'idLog', // To retrieve index of line which is nested toggled or not => nestedPointer = nestedPointerValuePath
			nestedPointerValuePath: 'props.row.idLog', // To retrieve value of line which is nested toggled or not => nestedPointer = nestedPointerValuePath
			toggleAllNestedPointer: 'toggleNested', // Are we seeing nested lines or not
		},
	})

	///////////////////////////////USE EFFECT//////////////////////////////////////

	useEffect(() => {
		const filtersCP = cloneDeep(filters)
		filtersCP.searchField = searchValue
		setFilters(filtersCP)
	}, [searchValue])

	useEffect(() => {
		if (filters.searchField !== searchValue || searchValue === logExtranet) return
		handleSubmit()
	}, [filters.searchField])

	useEffect(() => {
		if (dateTransactionStateDate.showModal) {
			actionsLogExtranet.postLogExtranet(handleFilterSend(), paging)
		}
	}, [dateTransactionShowModal])

	useEffect(() => {
		const cfg = cloneDeep(configTableTitle)

		cfg.paging = {
			totalElements: logExtranet.paging.totalElements,
			totalPages: logExtranet.paging.totalPages,
			fnSendTo: (paging) => handlePagingLogExtranet(paging),
		}
		setConfigTableTitle(cfg)
		//setInputData(logExtranet.items)
	}, [logExtranet])

	useEffect(() => {
		//if (isEmpty(translations)) return
		const filtersCp = cloneDeep(logExtranetFilters)
		filtersCp.withFilters = true

		setFilters(filtersCp)
		setPrevFilter(filtersCp)
	}, [logExtranetFilters])

	useEffect(() => {
		const filtersCp = cloneDeep(filters) // add fot he new filters method
		let cfg = cloneDeep(configTableTitle)

		cfg.name = translations['page__logAdmin__extranet__title']

		cfg.paging = {
			totalElements: logExtranet.paging.totalElements,
			totalPages: logExtranet.paging.totalPages,
			fnSendTo: (paging) => handlePagingLogExtranet(paging),
		}

		cfg.actions.dateLists = [
			() => (
				<Fragment>
					<label style={{ color: Theme.colors.table.body.text, marginRight: '10px', lineHeight: '32px' }}>
						{translations['page__logAdmin__filters_date']} :
					</label>
					<DatePickerTransactionIcon onClick={dateTransactionOpenDateModalHandler} />
					<DatePickerFilterLabel>
						<span>
							{translations['page__global__admin__header_datePicker_from']}{' '}
							{moment(dateTransactionStateDate.date.startDate).format('DD/MM/YYYY HH:mm')}
						</span>
						<span>
							{translations['page__global__admin__header_datePicker_to']}{' '}
							{moment(dateTransactionStateDate.date.endDate).format('DD/MM/YYYY HH:mm')}
						</span>
					</DatePickerFilterLabel>
				</Fragment>
			),
		]
		cfg.actions.rest = [
			() => (
				<DropdownCheckbox
					title={translations['page__logAdmin__filters_subCategory']}
					data={filtersCp.filtersSelection?.subCategory.filterElements || []}
					translations={translations}
					toTranslate={true}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'subCategory'}
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['page__logAdmin__filters_category']}
					data={filtersCp.filtersSelection?.category.filterElements || []}
					toTranslate={true}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'category'}
				/>
			),

			() => (
				<DropdownCheckbox
					title={translations['page__logAdmin__filters_status']}
					data={filtersCp.filtersSelection?.status.filterElements || []}
					toTranslate={true}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'status'}
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['page__logAdmin__filters_level']}
					data={filtersCp.filtersSelection?.level.filterElements || []}
					toTranslate={true}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'level'}
				/>
			),
		]

		setConfigTableTitle(cfg)
	}, [translations, filters, dateTransactionStateDate])

	useEffect(() => {
		const cfgCp = cloneDeep(configTable)
		cfgCp.export = {
			privilege: userPrivileges.export[15],
			url: urlExport[13],
			bd: {
				filtersSelection: filters.filtersSelection,
				searchField: searchValue,
				datesRange: { dateEnd: dateTransactionStateDate.date.endDate, dateStart: dateTransactionStateDate.date.startDate },
				withFilters: true,
				userKioskScope: {
					kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
				},
			},
		}
		setConfigTable(cfgCp)
	}, [translations, filters])

	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)

		cfg.actions.searchBarComponent = {
			handleSearchEnter: handleSearchEnter,
			handleClickSearch: handleClickSearch,
			placeholder: translations['common__text__fastFilter_search'],
			defaultValue: searchValue,
			handleReset: (refInput) => {
				refInput.current.value = ''
				setSearchValue('')
			},
		}

		setConfigTableTitle(cfg)
	}, [searchValue])

	useEffect(() => {
		if (isUndefined(user) || isEmpty(translations)) return
		if (isEmpty(filters)) {
			let state_date = {}
			state_date.startDate = moment().startOf('day').toDate()
			state_date.endDate = moment().hours(23).minutes(59).toDate()

			setStartDate(moment(state_date.startDate).toDate())
			setEndDate(moment(state_date.endDate).toDate())

			const filtersCp = {
				withFilters: false, //searchValue?.length > 0 ? true : false,
				userKioskScope: {
					kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
				},

				filtersSelection: null,
				datesRange: {
					// Dummy dates
					dateStart: state_date.startDate,
					dateEnd: state_date.endDate,
				},
				searchField: null,
				searchFieldUpdated: false,
			}
			actionsLogExtranet.postLogExtranet(filtersCp)
			actionsColumns.setColumns([])

			setFilters(filtersCp)
		}
	}, [user, translations])

	// If user is changing his perimeter, we need to make a back call
	useEffect(() => {
		if (!isEqual(userKioskPerimeter, currentPerimeterKiosks) && !isEmpty(currentPerimeterKiosks))
			actionsLogExtranet.postLogExtranet(handleFilterSend(), paging)
		setCurrentPerimeterKiosks(userKioskPerimeter)
	}, [userKioskPerimeter])

	useEffect(() => {
		return function cleanUp() {
			actionsLogExtranet.resetLogExtranet()
			actionsTable.resetPaggingConfig()
		}
	}, [])

	///////////////////////////////// RENDER ///////////////////////////////////////

	const TableRender = useMemo(() => {
		return (
			<Table
				inputColumns={columns}
				inputData={logExtranet.items}
				inputConfig={configTable}
				currentPaging={paging}
				isLoading={logExtranet.isLoading}
				tableReferential={tableReferential}
				actionSort={actionsLogExtranet.postLogExtranet}
			/>
		)
	}, [logExtranet, columns, configTable, translations, paging])
	return (
		<Fragment>
			{dateTransactionRenderModal()}
			<Modals
				title={translations['modal__transactionsHistory__admin__title__sendMerchantTicket']}
				closeModalHandler={handleModalTicket}
				showModal={showModalTicket}
				icon={true}
			>
				<TextModal>
					<p>{translations['modal__transactionsHistory__admin__body__sendMerchantTicket']}</p>
				</TextModal>
				<ButtonWrapper>
					<Button
						//actionHandler={ handleModalTicket }
						text={translations['common__text__cancel']}
						bgColor={Theme.colors.error}
						margin="true"
						img={Cancel}
					/>
					<Button
						//actionHandler={ () => {handleTicketAsk()} }
						text={translations['modal_transactionsHistory__admin__validation']}
						bgColor={Theme.colors.validation}
						img={Validation}
					/>
				</ButtonWrapper>
			</Modals>
			<UsersManagerWrapper>
				{!isUndefined(translations) && !isUndefined(configTableTitle) && (
					<TableTitle inputConfig={configTableTitle} inputColumns={columns} tableReferential={tableReferential} />
				)}
				{!isUndefined(translations) && !isUndefined(configTable) && TableRender}
			</UsersManagerWrapper>
		</Fragment>
	)
}

LogExtranetManager.propTypes = {}

LogExtranetManager.defaultPropTypes = {}

export default LogExtranetManager
